// @ts-strict-ignore
import { Updatable } from './updatable';

export const LOADING_START = 'LOADING_START';
export const LOADING_STOP = 'LOADING_STOP';

export interface LoadingActionPayloadType {
    actionName: Updatable | string;
    id?: number | string; // used to link actions that can be performed on multiple instances to a specific instance
}

interface LoadingStartAction {
    type: typeof LOADING_START;
    payload: LoadingActionPayloadType;
}

interface LoadingStopAction {
    type: typeof LOADING_STOP;
    payload: LoadingActionPayloadType;
}

export type LoadingActionType = LoadingStartAction | LoadingStopAction;

// Action Creators

export const loadingActionStart: (name: Updatable | string, id?: number | string) => LoadingActionType = (name, id) => {
    return {
        type: LOADING_START,
        payload: {
            actionName: name,
            id: id ?? null,
        },
    };
};

export const loadingStopAction: (name: Updatable | string, id?: number | string) => LoadingActionType = (name, id) => {
    return {
        type: LOADING_STOP,
        payload: {
            actionName: name,
            id: id ?? null,
        },
    };
};
